import { Controller, useFormContext } from 'react-hook-form';

import { AkselLocale, Checkbox as AkselCheckbox } from 'components/form/aksel';

export default function Checkbox({
	name,
	label,
	defaultChecked = false,
	size = 'medium',
	disabled = false,
	...rest
}) {
	const { control } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			defaultValue={defaultChecked}
			render={({
				field: {
					onChange,
					value,
					disabled: fieldDisabled,
					...fieldProps
				},
			}) => (
				<AkselLocale>
					<AkselCheckbox
						size={size}
						checked={!!value}
						onChange={event => onChange(event.target.checked)}
						{...fieldProps}
						{...rest}
						disabled={fieldDisabled || disabled}
					>
						{label}
					</AkselCheckbox>
				</AkselLocale>
			)}
		/>
	);
}
